'use client';

import { useTranslations } from 'next-intl';

import { T } from '@flipster/i18n';
import { TextButton } from '@flipster/react/design-system/text-button';
import { css } from '@flipster/styled-system/css';
import { stack } from '@flipster/styled-system/patterns';

import * as Accordion from '../../shared/faq-accordion/accordion';
import { faqItems } from '../constants';

export const FaqSection = () => {
  const t = useTranslations();

  return (
    <div className={stack({ gap: 24, w: '100%' })}>
      <p className={css({ textStyle: 'Title/L', color: 'content.default.level-5', w: '100%' })}>
        <T id='VIP.r260316.Faq' />
      </p>
      <Accordion.Root headingLevel={3} css={{ w: '100%' }}>
        {faqItems.map((item, index) => (
          <Accordion.Item key={index}>
            <Accordion.Header index={index + 1}>{t(item.questionKey)}</Accordion.Header>
            <Accordion.Panel
              css={{
                textStyle: 'Text/L/Regular',
                color: 'content.default.level-3',
                whiteSpace: 'pre-line',
              }}
            >
              {item.answerKeys.map((key) => (
                <p key={key}>{t(key)}</p>
              ))}
              {item.hasReportLink && (
                <>
                  {' '}
                  <TextButton
                    as='a'
                    color='accent'
                    size='large'
                    label={t('VIP.r260316.Report_button')}
                    href='/channel-verification/report'
                  />
                </>
              )}
            </Accordion.Panel>
          </Accordion.Item>
        ))}
      </Accordion.Root>
    </div>
  );
};
